export default "__VITE_ASSET__DzjFZ3oP__"